import { Coordinates } from "@evergis/sgis/es/baseTypes";
import { FillStyle, PolyRender } from "@evergis/sgis/es/renders/Poly";
import { LineMiterRender } from "./LineMiterRender";

export class NoneLineMiterRender extends LineMiterRender {
  get usageSize() {
    return this.strokeWidth;
  }

  createRings([x, y]: Coordinates, xMultiplier: number): Coordinates[][] {
    return [
      [
        [x + (this.miterSize / 2) * -xMultiplier, y],
        [x + this.miterSize * -xMultiplier, y],
      ],
    ];
  }

  createRender(miterRings: Coordinates[][]) {
    return new PolyRender(miterRings, {
      enclosed: false,
      fillColor: void 0,
      fillStyle: FillStyle.None,
      lineCap: "square",
      lineJoin: "round",
      strokeColor: this.color,
      strokeWidth: this.strokeWidth,
    });
  }
}
